import { IconProps } from '.';

const BedIcon = ({
  color = 'var(--color-sage-300)',
  customClasses,
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        className={customClasses}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.14709 0.264571C0.926756 0.220505 0.698274 0.277546 0.524508 0.42C0.350742 0.562454 0.25 0.775312 0.25 1.00001V8.5V14.5V16.5C0.25 16.9142 0.585786 17.25 1 17.25C1.41421 17.25 1.75 16.9142 1.75 16.5V15.25H18.25V16.5C18.25 16.9142 18.5858 17.25 19 17.25C19.4142 17.25 19.75 16.9142 19.75 16.5V8.5C19.75 8.08579 19.4142 7.75 19 7.75H7.74702C7.68758 5.27617 6.74605 3.52677 5.44403 2.3344C4.12201 1.12371 2.47823 0.530799 1.14709 0.264571ZM6.24652 7.75C6.18884 5.69761 5.42087 4.34715 4.43097 3.44061C3.63923 2.71555 2.67606 2.24898 1.75 1.96272V7.75H6.24652ZM1.75 9.25V13.75H18.25V9.25H1.75Z"
        fill={color}
      />
    </svg>
  );
};

export default BedIcon;
